import { createStyles } from '@material-ui/core';
import type { Theme } from '@material-ui/core';

const styles = (theme: Theme) => {
  return createStyles({
    desktopHeader: {
      display: 'grid',
      alignItems: 'center',
      background: theme.nav,
      fontSize: '0.7143rem',
      fontWeight: 700,
      borderRight: 'solid 10px',
      borderRightColor: theme.primary,
      borderBottom: 'solid 1px #959CA1',
      textTransform: 'uppercase',

      '-ms-grid-columns': '1fr',

      '@media print': {
        display: 'none'
      }
    },

    headerBar: {
      width: '100%',
      maxWidth: '1200px',
      justifySelf: 'center',
      display: 'grid',
      alignItems: 'center',
      paddingTop: 5,
      gridTemplateColumns: 'auto 1fr auto',
      gridColumnGap: 5,
      gridTemplateAreas: `'logo header nav'`,

      //ie hacks
      '-ms-grid-columns': 'auto 1fr auto',
      marginLeft: 'auto',
      marginRight: 'auto',

      '@media (min-width: 600px)': {
        width: '100%'
      }
    },

    logo: {
      gridColumnStart: 1,
      display: 'inline-block',
      gridArea: 'logo',

      margin: '0.536rem 0rem',
      marginLeft: '0.7143rem',
      userSelect: 'none',

      //ie hacks
      '-ms-grid-column': 1,

      '& img': {
        maxWidth: 220,
        maxHeight: 100,
        verticalAlign: 'middle',
        cursor: 'pointer',

        '@media(max-width: 414px) ': {
          maxWidth: '100px'
        }
      }
    },

    menuButton: {
      marginRight: '0.7143rem',
      color: theme.navText || '#1C2541',
      fontSize: '22px',
      justifySelf: 'end',
      gridColumnStart: 3,
      cursor: 'pointer',

      //ie hacks
      '-ms-grid-column': 3,
      '-ms-grid-row-align': 'center',

      '@media (min-width: 992px)': {
        display: 'none'
      }
    },

    title: {
      justifySelf: 'center',

      color: theme.navText || '#1C2541',
      cursor: 'pointer',
      userSelect: 'none',
      gridArea: 'header',
      gridColumnStart: 2,
      fontSize: '1rem',

      //ie hacks
      '-ms-grid-column': 2,
      '-ms-grid-row-align': 'center',
      '-ms-grid-column-align': 'center',

      '@media(max-width: 414px)': {
        fontSize: '1.8em',

        '&$short': {
          fontSize: '1rem'
        },

        '&$long': {
          fontSize: '0.8rem'
        }
      },

      '@media (min-width: 415px) and (max-width: 991px)': {
        fontSize: '2em',

        '&$short': {
          fontSize: '2.5em'
        },

        '&$long': {
          fontSize: '1em'
        }
      },

      '@media(min-width: 992px)': {
        maxWidth: '230px',

        '&$long': {
          fontSize: '1em',
          marginBlockStart: 0,
          marginBlockEnd: 0
        }
      }
    },

    short: {},

    long: {},

    leftTitle: {
      justifySelf: 'left'
    }
  });
};

export default styles;
